import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const JPGIcon = ({ color = '#B5BCBD', size = 40, ...props }) => (
  <svg
    viewBox="0 0 24 28"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.531 0c.469 0 .938.205 1.26.527l6.652 6.652c.352.352.528.792.557 1.26v17.642c0 .996-.82 1.787-1.788 1.787H1.788C.79 27.868 0 27.048 0 26.081V1.788C0 .79.82 0 1.788 0zm-.703 2.051H2.05v21.861l6.271-6.623a1.31 1.31 0 0 1 1.876 0l3.516 3.722 1.788-1.905a1.31 1.31 0 0 1 1.875 0l4.572 4.835V9.172h-5.334c-.996 0-1.787-.82-1.787-1.787V2.05zm.732 9.641a2.256 2.256 0 1 1 0 4.513 2.256 2.256 0 0 1 0-4.513zm1.32-8.176v3.605h3.604l-3.605-3.605z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

JPGIcon.propTypes = propTypes;

export default JPGIcon;
